const cardItems = [
  {
    title: '星际征途：新纪元',
    desc: '人类文明面临前所未有的挑战，一支精英舰队踏上跨越银河的终极征途…',
    image: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%20style%20with%20futuristic%20spaceship%20and%20distant%20galaxy%20nebula%20in%20background%2C%20dramatic%20cinematic%20lighting%20with%20deep%20blues%20and%20warm%20orange%20accents%2C%20clean%20composition%2C%20no%20text%2C%20no%20faces%2C%20simple%20dark%20background&width=500&height=700&seq=card-scifi1&orientation=portrait',
    tag: '科幻',
    score: '9.2',
    year: '2026',
  },
  {
    title: '迷雾追踪',
    desc: '一桩离奇失踪案牵出惊天阴谋，退休刑警孤身追凶深入迷雾之中的罪恶之城。',
    image: 'https://readdy.ai/api/search-image?query=Moody%20noir%20thriller%20movie%20poster%20style%2C%20rainy%20urban%20street%20at%20night%20with%20reflective%20wet%20pavement%2C%20single%20street%20lamp%20casting%20dramatic%20shadows%2C%20deep%20blues%20and%20warm%20amber%20tones%2C%20simple%20composition%2C%20no%20text%2C%20no%20faces&width=500&height=700&seq=card-suspense1&orientation=portrait',
    tag: '悬疑',
    score: '8.8',
    year: '2026',
  },
  {
    title: '笑林外传',
    desc: '一群性格迥异的室友在合租生活中闹出无数爆笑故事，欢乐治愈都市青年的日常。',
    image: 'https://readdy.ai/api/search-image?query=Bright%20cheerful%20comedy%20movie%20poster%20style%2C%20cozy%20apartment%20interior%20with%20warm%20sunlight%20streaming%20through%20windows%2C%20colorful%20decor%2C%20playful%20atmosphere%2C%20soft%20pastel%20colors%20with%20golden%20accents%2C%20no%20text%2C%20no%20faces&width=500&height=700&seq=card-comedy1&orientation=portrait',
    tag: '喜剧',
    score: '8.5',
    year: '2025',
  },
  {
    title: '暗夜守护者',
    desc: '当城市陷入黑暗，一个神秘组织浮出水面。正义与邪恶的边界在此模糊…',
    image: 'https://readdy.ai/api/search-image?query=Dark%20superhero%20action%20movie%20poster%20style%2C%20city%20skyline%20at%20night%20with%20dramatic%20moonlight%2C%20silhouette%20on%20rooftop%2C%20deep%20shadows%20with%20crimson%20accent%20lighting%2C%20cinematic%20composition%2C%20no%20text%2C%20no%20faces&width=500&height=700&seq=card-action1&orientation=portrait',
    tag: '动作',
    score: '9.0',
    year: '2026',
  },
  {
    title: '山海传说',
    desc: '取材自中国古典神话的全新动画巨制，上古神兽与凡人少年共同守护天地平衡。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20mythology%20fantasy%20movie%20poster%20style%2C%20ancient%20mountain%20landscape%20with%20mist%20and%20waterfalls%2C%20traditional%20ink%20painting%20influence%20with%20modern%20cinematic%20lighting%2C%20golden%20and%20jade%20green%20tones%2C%20no%20text%2C%20no%20faces&width=500&height=700&seq=card-fantasy1&orientation=portrait',
    tag: '奇幻',
    score: '9.5',
    year: '2026',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
            新片速递
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-500">
            最新上线的热门电影，第一时间享受高清观影
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {cardItems.map((item) => (
            <a
              key={item.title}
              href="#ranking"
              className="group block rounded-xl overflow-hidden bg-background-50 hover:bg-background-200 transition-colors cursor-pointer"
            >
              <div className="relative aspect-[2/3] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2 px-2 py-0.5 rounded bg-accent-500/90 text-white text-xs font-bold font-label">
                  {item.score}
                </div>
                <div className="absolute top-2 right-2 px-2 py-0.5 rounded bg-background-950/70 text-background-100 text-xs font-label">
                  {item.year}
                </div>
                <div className="absolute bottom-2 left-2 px-2 py-0.5 rounded bg-primary-500/90 text-white text-xs font-medium font-label">
                  {item.tag}
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm md:text-base font-bold font-heading text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}